// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../GeneratePriceModal/GeneratePriceModal.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-description {
  font-size: 14px;
  color: #6c748b;
  margin-top: -10px;
  margin-bottom: 24px;
}

.checkin-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.checkin-input-group label {
  display: block;
  font-size: 14px;
  color: #3a445d;
  margin-bottom: 8px;
}

.checkin-input-group input {
  width: 100%;
  padding: 12px;
  border: 1px solid #d9dce1;
  border-radius: 8px;
  font-size: 14px;
  box-sizing: border-box;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.checkin-input-group input:focus {
  outline: none;
  border-color: #00875a;
  box-shadow: 0 0 0 3px rgba(0, 135, 90, 0.2);
}

.confirm-btn {
  background-color: #00875a;
  color: white;
  border: none;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.confirm-btn:hover:not(:disabled) {
  background-color: #00694a;
}

.confirm-btn:disabled {
  background-color: #cce8e0;
  cursor: not-allowed;
}

@media (max-width: 600px) {
  .checkin-form {
    gap: 12px;
  }
  .confirm-btn {
    padding: 8px 16px;
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/compoonents/ParcelCheckinModal/ParcelCheckinModal.css"],"names":[],"mappings":"AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB;;mBAEiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":["@import \"../GeneratePriceModal/GeneratePriceModal.css\";\n\n.modal-description {\n  font-size: 14px;\n  color: #6c748b;\n  margin-top: -10px;\n  margin-bottom: 24px;\n}\n\n.checkin-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.checkin-input-group label {\n  display: block;\n  font-size: 14px;\n  color: #3a445d;\n  margin-bottom: 8px;\n}\n\n.checkin-input-group input {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #d9dce1;\n  border-radius: 8px;\n  font-size: 14px;\n  box-sizing: border-box;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.checkin-input-group input:focus {\n  outline: none;\n  border-color: #00875a;\n  box-shadow: 0 0 0 3px rgba(0, 135, 90, 0.2);\n}\n\n.confirm-btn {\n  background-color: #00875a;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.confirm-btn:hover:not(:disabled) {\n  background-color: #00694a;\n}\n\n.confirm-btn:disabled {\n  background-color: #cce8e0;\n  cursor: not-allowed;\n}\n\n@media (max-width: 600px) {\n  .checkin-form {\n    gap: 12px;\n  }\n  .confirm-btn {\n    padding: 8px 16px;\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
